/*
 * @Description: 心智占有率-单表
 * @Author: yy
 * @LastEditors: yy
 * @Date: 2019-02-20 16:03:00
 * @LastEditTime: 2019-08-29 11:25:54
 */


const createTitle = (data) => ({
  text: `心智占有率 - ${data.industry}`, // - ${data.brandName}`,
  subtext: '数据来源：数字品牌榜',
  x: '20'
});


const createGraphic = (list) => {
  return list.concat([
    {
      type: 'rect',
      z: 80,
      left: '20',
      top: '60',
      shape: {
        width: 230,
        height: 44
      },
      style: {
        fill: '#ffd70d',
        stroke: '#999'
      }
    }, {
      type: 'text',
      left: '20',
      top: 65,
      z: 100,
      style: {
        text: ' ● 阴影区颜色为黄色，表明好感度为正值；',
        stroke: '#ffd70d',
        font: '12px "STHeiti", sans-serif'
      }
    }, {
      type: 'text',
      left: '30',
      top: 85,
      z: 100,
      style: {
        text: ' 若为蓝色，表明好感度为负值。',
        stroke: '#44548f',
        font: '12px "STHeiti", sans-serif'
      }
    }
  ]);
};

const itemStyle = {
  normal: {
    opacity: 0.7,
    borderWidth: 1,
    borderColor: '#000'
  }
};

export default (data, opt) => {

  let count = 0;

  const list = data
  .sort((a, b) => b.db - a.db)
  .map((item) => {
    count += Math.abs(item.db)
    return {
      value: Math.abs(item.db),
      name: item.name,
      itemStyle: {
        normal: {
          color: item.db < 0 ? '#44548f' : '#ffd70d'
        }
      }
    }
  })
  // .sort((a, b) => {
  //   let prev = a.industry_mind.replace('%', '') - 0
  //   let next = b.industry_mind.replace('%', '') - 0
  //   return next - prev
  // })


  const timeText = opt.time || 0

  const option = {
    graphic:[{
      type: 'rect',
      left: opt.timeLeft || '59%',
      top: 5,
      z: 99,
      shape: {
        width: timeText.length * 10.5,
        height: 20
      },
      style: {
        fill: '#ffd70d'
      }
    }, {
      type: 'text',
      left: opt.timeLeft || '59%',
      top: 10,
      z: 100,
      style: {
        text: timeText,
        fill: '#000',
        font: '12px "STHeiti", sans-serif'
      }
    }],
    color: ['#ffd70d'],
    calculable: true,
    series: [
      {
        z: 10,
        name: '心智占有率',
        type: 'pie',
        radius: [
          '20%', '60%'
        ],
        center: opt.center || [
          '50%', '50%'
        ],
        startAngle:90,
        roseType: 'area',
        avoidLabelOverlap: true,
        label: {
          normal: {
            // formatter: '{b|{b}}\n{hr|}\n{a|{a}：}{per|{d}%}\n{hr|}\n {a|DB值：}{per|{c}}',
            // formatter: `{b|{b}} {per|{d}%}`,
            formatter (params, ...arg) {
              return `{b|${params.name}} {per|${Math.round(params.value/count * 10000) / 100}%}` 
            },
            // formatter: function(params,data){
            //   console.log(params,data)
            //   return `{b|${params.name}}${params.color=='#ccc'?'-':''}{per|{d}}%}`
            // },
            backgroundColor: '#f2f2f2',
            borderColor: '#aaa',
            // borderWidth: 1,
            borderRadius: 4,
            padding: [
              0, 0
            ],
            // shadowBlur:3, shadowOffsetX: 2, shadowOffsetY: 2, shadowColor: '#999',
            // padding: [0, 7],
            rich: {
              a: {
                color: '#999',
                lineHeight: 22,
                align: 'center'
              },
              // abg: {     backgroundColor: '#333',     width: '100%',     align: 'right',
              //  height: 22,     borderRadius: [4, 4, 0, 0] },
              hr: {
                borderColor: '#aaa',
                width: '100%',
                borderWidth: 0.5,
                height: 0
              },
              b: {
                fontSize: 14,
                lineHeight: 25,
                color: '#333',
                align: 'center'
              },
              per: {
                color: '#eee',
                backgroundColor: '#334455',
                align: 'center',
                padding: [
                  2, 4
                ],
                borderRadius: 2,
                fontSize:14,
              }
  
            }
          },
          emphasis: {
            show: true
          }
  
        },
        lableLine: {
          normal: {
            show: true
          },
          emphasis: {
            show: true
          }
        },
        data: list,
        itemStyle: itemStyle
      }
  
    ]
  };

  if (opt.title) {
    option.title = createTitle({
      industry: '品牌对比',
      brandName: list.map(item => item.name).join(' vs ')
    });
  }
  if (opt.graphic) {
    option.graphic = createGraphic(option.graphic)
  }

  return option;
};


// WEBPACK FOOTER //
// src/chart/shareOfMindSingle.js